import { NotificationCenter } from "@/components/notifications/NotificationCenter";

/** D-043 S2 — /notifications (TZ §6.2). */
export function NotificationsPage() {
  return <NotificationCenter />;
}
